module.exports = __webpack_public_path__ + "img/1212a_2.1e8bc009.jpg";